export default {
  homePage: '홈',
  chatPage: '채팅',
  contactUs: '문의',
  submitRequest: '요청 제출',
  question: '질문',
  subject: '제목',
  description: '설명',
  email: '사용자 이메일',
  attach: '파일을 최대 4개까지 첨부하세요. 파일 크기는 10MB를 넘을 수 없습니다.',
  delete: '삭제',
  sizeExceeded: '파일 크기는 10MB를 넘을 수 없습니다.',
  numberExceeded: '파일은 최대 4개까지 첨부할 수 있습니다.',
  wrongFormat: '첨부 파일은 다음 형식이어야 합니다: .jpg, .jpeg, .png, .bmp, .tif, .tiff, .gif, .webp, .avi, .mp4, .mov, .flv, .mkv, .webm, .txt, .csv.',
  send: '전송',
  messageSent: '메시지를 전송했습니다. 저희 지원 팀이 요청을 검토한 후에 입력하신 이메일 주소로 연락 드리겠습니다.',
  formUnavailable: '현재 티켓 생성 양식을 이용할 수 없습니다. 지원 센터를 통해 티켓을 제출할 수 있습니다.',
  helpCenter: '지원 센터로 갑니다.',
  issueEmpty: '질문 유형을 선택해 주세요.',
  subjEmpty: '문의 사항의 제목을 입력해 주세요.',
  descEmpty: '질문을 입력해 주세요.',
  emailInvalid: '이메일 주소를 입력해 주세요. 이메일이 정확한지 확인해 주세요.',
  // Issue types
  type: '질문 유형을 선택하세요',
  gameQuestion: '게임 질문',
  techIssue: '기술 문제',
  paymIssue: '결제 문제',
  gameplayIssues: '게임플레이 문제',
  feedback: '피드백 및 제안',
  dpo: '개인정보 보호 요청 / DPO 연락',
  // GDPR form
  gdprCheckbox: `위 약관을 읽고 이해했습니다.`,
  gdprType: '삭제 이유를 선택하세요(선택 사항)',
  gdprRestart: '새 게임을 시작하고 싶어서',
  gdprBored: `게임이 마음에 들지 않아서`,
  gpdrMultiacc: `다른 계정이 있어 이 계정이 필요 없어서`,
  gdprExpectations: `게임이 기대에 미치지 못해서`,
  gdprDataSafety: `내 개인 정보를 공유하지 싶지 않아서`,
  gdprPrices: '게임에 돈이 많이 들어서',
  gdprOther: '기타',
  gdprCreate: `<p>여기서 계정 및 모든 관련 정보의 완전 삭제를 요청할 수 있습니다. 특정 서버의 게임 프로필만 삭제하시려면, 메인 게임 화면의 톱니바퀴 아이콘을 누르고 아래로 내려가 지원 옵션 옆의 열기를 누릅니다. 채팅에서 계정 및 개인정보 → 계정 삭제 → 서버에서 프로필 삭제를 누릅니다.</p>
<p>정보 삭제를 선택하면 모든 진행 상황, 점수, 업적이 사라집니다. <strong>모든 서버의 진행 상황이 전부 삭제되며, 되돌릴 수 없습니다. 저희 서버에서도 모두 삭제됩니다</strong>.</p>
<p>저희는 관련 법에 따라 엄격하게 귀하의 정보를 보호하고 귀하의 권리를 존중합니다. 저희는 귀하의 프로젝트 이용에 필요한 정보만 수집합니다. 정보 삭제 요청 완료 후에 프로젝트를 실행하면, 저희<a href="https://www.nexters.com/hwa/tos_ko/"> 이용 약관</a>과<a href="https://www.nexters.com/hwa/privacy_ko/">개인정보 처리방침</a>을 다시 수락해야 합니다. 수락 시 정보를 다시 수집합니다. 요청이 완료될 때까지는 <a href="https://www.nexters.com/hwa/tos_ko/">이용 약관</a>과 <a href="https://www.nexters.com/hwa/privacy_ko/">개인정보 처리방침</a>을 추가로 수락하지 않고도 진행 상황과 업적을 이용할 수 있습니다.</p>
<p>이 요청을 확인하시면, 확인 날짜부터 30일 이내에 완료됩니다. 참고로 이 기한은 최대 기한입니다. 따라서, 내부 요청 처리 절차에 따라 요청이 더 빨리 완료될 수도 있습니다. 정보 삭제 요청은 되돌릴 수 없으니 신중하게 결정해 수세요.</p>
또한, 도중에 마음이 바뀌어서 요청을 취소할 수 있는 기한은 14일입니다. 요청을 취소하려면:
<ol><li>메인 게임 화면 오른쪽 위의 톱니바퀴 아이콘을 누르고, 아래로 내려가 게임 서버에서 내 계정 및 모든 데이터 삭제옵션 옆의 열기를 누릅니다. 취소 버튼을 찾습니다. 누르면 요청을 취소합니다.</li>
<li>아니면 챗봇을 이용해 요청을 취소할 수도 있습니다. 메인 게임 화면 오른쪽 위의 톱니바퀴 아이콘을 누르고, 아래로 내려가 지원 옵션 옆의 열기를 누릅니다. 채팅에서 계정 및 개인정보 → 계정 삭제 → Hero Wars 계정 삭제 → 계정 삭제 요청 취소를 누릅니다.</li></ol>
<p>위 조건에 동의하고 계속 진행하려면 확인을 눌러주세요.</p>`,
  confirm: '확인',
  gdprConfirmed1: '삭제 요청을 수락했습니다. 요청 생성 일자부터 30일 이내에 모든 서버의 진행 상황이 전부 삭제되며, 이는 되돌릴 수 없습니다:',
  gdprConfirmed2: `<p>이 요청은 첫 14일 이내에 취소할 수 있습니다. 취소하려면:
<ol><li>메인 게임 화면 오른쪽 위의 톱니바퀴 아이콘을 누르고, 아래로 내려가 게임 서버에서 내 계정 및 모든 데이터 삭제옵션 옆의 열기를 누릅니다. 취소 버튼을 찾습니다. 누르면 요청을 취소합니다.</li>
<li>아니면 챗봇을 이용해 요청을 취소할 수도 있습니다. 메인 게임 화면 오른쪽 위의 톱니바퀴 아이콘을 누르고, 아래로 내려가 지원 옵션 옆의 열기를 누릅니다. 채팅에서 계정 및 개인정보 → 계정 삭제 → Hero Wars 계정 삭제 → 계정 삭제 요청 취소를 누릅니다.</li></ol></p>
<p>7일과 14일 후에 게임 내 메일로 상기 메일을 받습니다. <strong>14일 후에는 계정 삭제 요청을 취소할 수 없습니다.</strong></p>`,
  gdprCancel: `<p>계정 삭제 요청을 취소하려면 내 계정 삭제 취소 버튼을 누르세요.</p>`,
  gdprCancelConfirmed: `<p>저희는 관련 법에 따라 적절한 수준으로 귀하의 정보를 엄격하게 보호하고 귀하의 권리를 존중합니다.</p>
  <p><strong><strong>귀하의 요청에 따라 삭제 문의를 취소했으며, 진행 상황도 삭제하지 않겠습니다.</strong></p>
  <p>정보를 계속 수집합니다.</p>`,
  gdprCancelButton: `내 계정 삭제 취소`,
  // Meya 
  digestEmpty: '안녕하세요! 게임 관련 질문이 있으시다면, 저희 지원 팀이 언제든 도와드리겠습니다!',
  loadingChat: '채팅 불러오는 중...',
  loadingChatStart: `채팅 버튼이 표시되지 않는다면 `,
  loadingChatLink: `여기를 `,
  loadingChatEnd: `클릭해 주세요!`,
  openChat: '채팅',
  // Links
  hcLink: 'https://support-hwa.nexters.com/hc/en-us',
  // Help Center
  popularTopics: '추천 게시물',
  search: '검색',
  searchResults: '- 결과',
  showAll: '전체 보기',
  error: '문제가 발생했습니다. 나중에 다시 시도하세요.',
}